module.exports = __webpack_public_path__ + "img/antes_despues_107.0809ed23.png";